import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as userBookmarksActions from './userBookmarksActions';
import { Card, Dimmer, Loader } from 'semantic-ui-react';

class UserBookmarks extends Component {
    
    componentDidMount(){
        const { userBookmarksActions } = this.props;
        userBookmarksActions.onGetUserAllBookmarks();
    }

    renderBookmarks(bookmarkLists) 
	{
		if (bookmarkLists && bookmarkLists.length > 0){
			return bookmarkLists.map(bookmarks=> { return (
                <div style={{width: '100%', wordWrap: 'break-word'}}>
                    
				<Card
				key={bookmarks.Id}
				link
				fluid
				header={bookmarks.StoryTitle}
				meta={bookmarks.URL}
				extra={bookmarks.UserId}
				onClick={this.onHandleChange}
				description={bookmarks.Description !==null ? bookmarks.Description.substr(0, 200): bookmarks.Descriptions !== undefined && bookmarks.Descriptions.length >=1 ? bookmarks.Descriptions[0].Description.substr(0, 200) : '' }
	  />
      </div>
			)});
		}
	}


	render() {
        const { userAllBookmarks, isLoading }=this.props;
		return (
			<div style={{width:'100%', marginTop:'10px' }}>
            <Dimmer.Dimmable dimmed={isLoading}>
			<div style={{height: 40}}>
			<Dimmer active={isLoading} inverted={true}>
              <Loader>Loading</Loader>
            </Dimmer>
			</div>

            {this.renderBookmarks(userAllBookmarks)}

            </Dimmer.Dimmable>
            </div>
		);
	}
}


const mapStateToProps = ({ userBookmarks }) => {
	const { isLoading, userAllBookmarks } = userBookmarks;
	return {
	  isLoading,
	  userAllBookmarks,
	};
  };
  


const mapDispatchToProps = (dispatch) => {
	return {
		userBookmarksActions: bindActionCreators(userBookmarksActions, dispatch),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserBookmarks));